import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import TextDate from './../../components/text/TextDate';
import TextAmount from 'components/text/TextAmount';



export const LINClaimList = ({list, isClaimNumber = false})  => {

    if (!list){
        return null;
    }    


  return (                 
        <div>
            <span>Fjöldi færslna í lista {list.length}</span>
            <div className="table-wrap">
                <table className="table advanced hover ">
                    <colgroup>
                        {isClaimNumber && <col />}                        
                        <col width="48%" />
                        <col />
                        <col />
                        <col />
                        <col />
                    </colgroup>
                    <thead>
                        <tr>
                            {isClaimNumber && <th className="no-right-border">Kröfunúmer</th>}
                            <th className="no-right-border">Skuldari/Ábyrgðarmaður</th>
                            <th className="no-right-border no-left-border ">Tilvísun</th>
                            <th className="no-right-border no-left-border">Gjalddagi</th>
                            <th className="no-right-border no-left-border">Eindagi</th>
                            <th className="no-right-border no-left-border">Upphæð</th>
                        </tr>
                    </thead>
                    <tbody>
                    {list.map((claim, index) =>                             
                        <tr key={index} className="ci-animate-repeat">                        
                            {isClaimNumber && <th className="no-right-border">{claim.isClaimNumber}</th>}    
                            {claim.isError && (<td ng-show="claim.isError" colspan="3">{claim.inputLine}</td>)}
                            {claim.isError && (<td ng-show="claim.isError" colspan="2"> Villa í innlestrarlínu </td>)}
                            {!claim.isError && (<td className="no-left-border">
                                {claim.debtors.map((debtor, dindex) => 
                                            <div key={dindex}>
                                                {debtor.regno} &nbsp; {debtor.name} &nbsp; 
                                                <span className="tag tag-debtor-type-{{debtor.debtorTypeID}}">{debtor.debtorTypeName}</span> <br/>                                                                                    
                                            </div>)
                                    }                                                                      
                            </td>)}
                            {!claim.isError && (<td className="no-left-border " ng-show="!claim.isError">{claim.referenceNumber }</td>)}
                            {!claim.isError && (<td className="no-left-border " ng-show="!claim.isError"><TextDate value={claim.dueDate }/></td>)}
                            {!claim.isError && (<td className="no-left-border " ng-show="!claim.isError"><TextDate value={claim.finalDueDate }/></td>)}
                            {!claim.isError && (<td className="no-left-border text-right" ng-show="!claim.isError"><TextAmount value={claim.amount}/></td>)}
                        </tr>)}
                    </tbody>
                </table>
            </div>
        </div>         
    
  );
};

LINClaimList.propTypes = {
    list: PropTypes.array,  
};